import { render, staticRenderFns } from "./goodsCard.vue?vue&type=template&id=6f02c89a&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./goodsCard.vue?vue&type=style&index=0&id=6f02c89a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f02c89a",
  null
  
)

export default component.exports